import classnames from 'classnames';
import React from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import { PillSize } from "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import { Privacy } from "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { FontIcon } from "../../../atoms/icon/font-icon/font-icon.js";
import '@brandfolder/utilities';
import { BadgePill } from "../../../atoms/pill/badge/badge-pill.js";
import { CircleStatus } from "../../../atoms/status/circle/circle-status.js";
import classes from "./styles/privacy-badge.module.scss.js";
var baseName = 'privacy-badge';
var PrivacyBadge = function PrivacyBadge(props) {
  var children = props.children,
    privacyLevel = props.privacyLevel,
    _props$showIcon = props.showIcon,
    showIcon = _props$showIcon === void 0 ? false : _props$showIcon,
    _props$showText = props.showText,
    showText = _props$showText === void 0 ? true : _props$showText;
  var privacyIcon = function privacyIcon() {
    if (privacyLevel.includes(Privacy.Private)) {
      return /*#__PURE__*/React.createElement(FontIcon, {
        className: classnames(classes["bf-".concat(baseName, "__icon")]),
        icon: FontIcons.Private,
        iconSize: 11
      });
    } else if (privacyLevel.includes(Privacy.Stealth)) {
      return /*#__PURE__*/React.createElement(FontIcon, {
        className: classnames(classes["bf-".concat(baseName, "__icon")]),
        icon: FontIcons.Private,
        iconSize: 11
      });
    } else {
      return /*#__PURE__*/React.createElement(FontIcon, {
        className: classnames(classes["bf-".concat(baseName, "__icon")]),
        icon: FontIcons.Public,
        iconSize: 11
      });
    }
  };
  var privacyText = function privacyText() {
    var privateText = privacyLevel.includes(Privacy.Private);
    var stealthText = privacyLevel.includes(Privacy.Stealth);
    if (privateText) {
      return /*#__PURE__*/React.createElement("span", {
        className: classnames(classes["bf-".concat(baseName, "__label")])
      }, children);
    } else if (stealthText) {
      return /*#__PURE__*/React.createElement("span", {
        className: classnames(classes["bf-".concat(baseName, "__label")])
      }, children);
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: classnames(classes["bf-".concat(baseName, "__label")])
      }, children);
    }
  };
  return /*#__PURE__*/React.createElement(BadgePill, {
    className: classnames("bf-".concat(baseName), classes["bf-".concat(baseName)]),
    backgroundColor: BrandfolderHexColors.DirtyMarshmallow,
    size: PillSize.XSmall
  }, /*#__PURE__*/React.createElement(CircleStatus, {
    className: classnames(classes["bf-status__circle--".concat(privacyLevel)]),
    size: 7
  }), showIcon && privacyIcon(), showText && privacyText());
};
export { PrivacyBadge };